import { useEffect, useState } from "react";
import styles from "./FaqPage.module.css";

export default function FaqPage() {
  const [faqData, setFaqData] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetch("/data/faq.json")
      .then((res) => res.json())
      .then((data) => setFaqData(data))
      .catch((err) => console.error("Failed to load questions file:", err));
  }, []);

  function renderAnswer(answer) {
    if (!answer) return null;

    if (typeof answer === "string") {
      return <>{answer}</>;
    }

    if (typeof answer === "object" && answer.text && answer.link) {
      return (
        <>
          {answer.text}
          <a
            href={answer.link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
            onClick={(e) => e.stopPropagation()}
          >
            {answer.link.text}
          </a>
          .
        </>
      );
    }

    return null;
  }

  function handleKeyDown(event, index) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setOpenIndex(openIndex === index ? null : index);
    }
  }

  const filteredFaqs = faqData.filter((item) =>
    item.question.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>❓ Frequently Asked Questions</h1>

      <div className={styles.searchBarContainer}>
        <input
          type="text"
          className={styles.searchInput}
          placeholder="Search questions..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          aria-label="Search questions"
        />
      </div>

      {filteredFaqs.length === 0 ? (
        <p className={styles.loading}>No matching questions found.</p>
      ) : (
        <div className={styles.faqList}>
          {filteredFaqs.map((item, index) => (
            <div
              key={index}
              tabIndex={0}
              role="button"
              aria-expanded={openIndex === index}
              className={`${styles.faqItem} ${
                openIndex === index ? styles.open : ""
              }`}
              onClick={() =>
                setOpenIndex(openIndex === index ? null : index)
              }
              onKeyDown={(e) => handleKeyDown(e, index)}
            >
              <div className={styles.question}>{item.question}</div>
              {openIndex === index && (
                <div className={styles.answer}>{renderAnswer(item.answer)}</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
